import React from 'react'

import { REPEAT_BOOKING } from '../../../../helpers'

const RepeatEndOccurrence = (props) => {
  const {
    className,
    isSelected,
    occurrence,
    language,
    onChange,
  } = props

  const viewStyle = isSelected ? 'box-active-option' : 'box-option'

  return (
    <div className={`${viewStyle} ${className}`}>
      <input
        className='occurrence-input'
        value={`${occurrence}`}
        maxLength={2}
        onChange={(event) => onChange(event.target.value, language)}
      />
      <label className='occurrence-input'>{REPEAT_BOOKING.OCCURRENCES[language]}</label>
    </div>
  )
}

export default RepeatEndOccurrence
